import { ActionReducer } from '@ngrx/store';

import { ShipmentDetailsActionTypes } from '../actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function resetShipmentFeatureState(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action.type === ShipmentDetailsActionTypes.RESET_SHIPMENT_FEATURE) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
